import {
  FixedBanner,
  Card,
  SkeletonBox,
  TextInput,
} from '@circlefin/components'
import { GraphQLErrorBoundary } from '@shared/components/errors'
import { FormGrid } from '@shared/components/form'
import {
  useDefaultPaymentMethodQuery,
  useSubscriptionsQuery,
} from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

/**
 * Auto Pay Detail Component to show details of an entity's autopay settings.
 */
export const AutoPayDetails: React.FC = () => {
  const { t } = useTranslation('settings')
  const subscription = useSubscriptionsQuery()
  const { data, loading, error, refetch } = useDefaultPaymentMethodQuery()

  return (
    <SkeletonBox
      className="h-48 rounded-lg"
      loading={loading || subscription.loading}
    >
      <FixedBanner
        data-testid="info-alert"
        status="warning"
        visible={!data?.defaultPaymentMethod && !error}
      >
        <FixedBanner.Description>{t`billing.autopay-detail.label.noDefault`}</FixedBanner.Description>
      </FixedBanner>

      <Card data-testid="autopay-details-card">
        <Card.Content className="px-10 pb-0 pt-2">
          <GraphQLErrorBoundary error={error} retry={refetch}>
            <FormGrid>
              <FormGrid.Element>
                <TextInput
                  label={t('billing.autopay-detail.label.withdrawalDate')}
                  value={t('billing.autopay-detail.label.firstMonth')}
                />
              </FormGrid.Element>
              {data?.defaultPaymentMethod && (
                <FormGrid.Element>
                  <TextInput
                    label={t('billing.autopay-detail.label.paymentMethod')}
                    value={t(
                      `billing.autopay-detail.label.${data?.defaultPaymentMethod.type}`,
                    )}
                  />
                </FormGrid.Element>
              )}
              <FormGrid.Element>
                <TextInput
                  label={t('billing.autopay-detail.label.paymentAmount')}
                  value={t('billing.autopay-detail.label.fullBalance')}
                />
              </FormGrid.Element>
            </FormGrid>
          </GraphQLErrorBoundary>
        </Card.Content>
      </Card>
    </SkeletonBox>
  )
}
